import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { CheckboxGroup, RadioGroup, withTooltips, Accordion } from '../../components/shared';
import { Valuer, RatingsContainer } from './components';

import { dict } from './../../submissions/constants';
import { ContactUs } from '../../submissions/components';

const { accordion } = dict;
const accordionArray = [accordion.standard, accordion.conditional, accordion.biExcluded];
const tooltips = ['<p>foo</p>', 'bar', 'baz'];
const SuggestionBox = ({ head, subHeader, body, footer }) => {
    return (
        <div className="suggestion-box text-left">
            <div>
                <strong>{head}</strong>:<span className="text-success ml">{subHeader}</span>
            </div>
            <div dangerouslySetInnerHTML={{ __html: body }} className="mt" />
            <i>{footer}</i>
        </div>
    );
};
export default function ZigiZone() {
    const CheckboxGroupWithTooltips = withTooltips(CheckboxGroup, tooltips);
    const RadioGroupWithTooltips = withTooltips(RadioGroup, tooltips);
    const AccordionRadio = Accordion(RadioGroup, accordionArray, SuggestionBox);
    const AccordionCheckbox = Accordion(CheckboxGroup, accordionArray);

    return (
        <div className="container">
            <h2>ZigiZone</h2>
            <p>Owner's Edge Components Catalog</p>
            <h3>Forms</h3>
            <hr />
            <Row>
                <Col sm={12} md={6}>
                    <h4>Radio Group Component</h4>
                    <Valuer value={'apple'}>
                        <RadioGroup
                            options={[
                                {
                                    label: 'Apple',
                                    value: 'apple'
                                },
                                {
                                    label: 'Orange',
                                    value: 'orange'
                                },
                                {
                                    label: 'Banana',
                                    value: 'banana'
                                }
                            ]}
                            name="fruits-1"
                        />
                    </Valuer>
                    <h4>Radio Group with Tooltip</h4>
                    <Valuer value={'apple'}>
                        <RadioGroupWithTooltips
                            options={[
                                {
                                    label: 'Apple',
                                    value: 'apple'
                                },
                                {
                                    label: 'Orange',
                                    value: 'orange'
                                },
                                {
                                    label: 'Banana',
                                    value: 'banana'
                                }
                            ]}
                            name="fruits-2"
                            className="coverage-option"
                        />
                    </Valuer>
                </Col>
                <Col sm={12} md={6}>
                    <h4>Checkbox Group Component</h4>
                    <Valuer value={['apple']}>
                        <CheckboxGroup
                            options={[
                                {
                                    label: 'Apple',
                                    value: 'apple'
                                },
                                {
                                    label: 'Orange',
                                    value: 'orange'
                                },
                                {
                                    label: 'Banana',
                                    value: 'banana'
                                }
                            ]}
                            name="fruits-3"
                        />
                    </Valuer>
                    <h4>Checkbox Group Component with Tooltip</h4>
                    <Valuer value={['apple']}>
                        <CheckboxGroupWithTooltips
                            options={[
                                {
                                    label: 'Apple',
                                    value: 'apple'
                                },
                                {
                                    label: 'Orange',
                                    value: 'orange'
                                },
                                {
                                    label: 'Banana',
                                    value: 'banana'
                                }
                            ]}
                            name="fruits-4"
                            className="coverage-option"
                        />
                    </Valuer>
                </Col>
            </Row>

            <h3>Ratings</h3>
            <hr />
            <RatingsContainer />

            <div className="row mb mt">
                <div className="col-xs-6">
                    <div className="card">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Simple card</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="card has-shadow">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Simple card with shadow</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <div className="row mb">
                <div className="col-xs-6">
                    <div className="card card-primary">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Simple card with primary state</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="card card-primary active">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Active card with primary state</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <div className="row mb">
                <div className="col-xs-6">
                    <div className="card card-warning">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Simple card with warning state</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="card card-warning active">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Active card with warning state</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <div className="row mb">
                <div className="col-xs-6">
                    <div className="card card-danger">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Simple card with danger state</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="card card-danger active">
                        <section className="pt pb pl-x2 pr-x2">
                            <h3>Active card with danger state</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                            <p>
                                Nullam non lacus efficitur, convallis sem quis, viverra justo.
                                Mauris commodo, turpis at pulvinar scelerisque, lacus purus sagittis
                                risus, quis porta justo risus a quam. Proin tristique nibh eros, a
                                convallis urna congue ac. In nec semper ante. Cras egestas eros
                                eros, at blandit ipsum auctor a. Curabitur quam enim, sagittis
                                sodales elementum ut, egestas in lectus. Ut in mattis magna, ut
                                suscipit lacus. Vivamus arcu sapien, scelerisque rhoncus viverra
                                vitae.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <div className="row mb">
                <div className="col-xs-4">
                    <div className="card">
                        <header className="pt pb pl-x2 pr-x2 bb">
                            <h3>Simple card with header and footer</h3>
                        </header>
                        <section className="pt pb pl-x2 pr-x2">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                        </section>
                        <footer className="pt pb pl-x2 pr-x2 bt">
                            <button className="btn btn-default">Call to action</button>
                        </footer>
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="card card-primary">
                        <header className="pt pb pl-x2 pr-x2 bb">
                            <h3>Card with header and footer in primary state</h3>
                        </header>
                        <section className="pt pb pl-x2 pr-x2">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                        </section>
                        <footer className="pt pb pl-x2 pr-x2 bt">
                            <button className="btn btn-default">Call to action</button>
                        </footer>
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="card card-primary active">
                        <header className="pt pb pl-x2 pr-x2 bb">
                            <h3>Active with header and footer in primary state</h3>
                        </header>
                        <section className="pt pb pl-x2 pr-x2">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                        </section>
                        <footer className="pt pb pl-x2 pr-x2 bt">
                            <button className="btn btn-default">Call to action</button>
                        </footer>
                    </div>
                </div>
            </div>
            <div className="row mb">
                <div className="col-xs-4">
                    <div className="card has-shadow">
                        <header className="pt pb pl-x2 pr-x2 bb">
                            <h3>Simple card with header and footer (w/ shadow)</h3>
                        </header>
                        <section className="pt pb pl-x2 pr-x2">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                        </section>
                        <footer className="pt pb pl-x2 pr-x2 bt">
                            <button className="btn btn-default">Call to action</button>
                        </footer>
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="card card-primary has-shadow">
                        <header className="pt pb pl-x2 pr-x2 bb">
                            <h3>Card w/ header and footer in primary state (w/ shadow)</h3>
                        </header>
                        <section className="pt pb pl-x2 pr-x2">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                        </section>
                        <footer className="pt pb pl-x2 pr-x2 bt">
                            <button className="btn btn-default">Call to action</button>
                        </footer>
                    </div>
                </div>
                <div className="col-xs-4">
                    <div className="card card-primary active has-shadow">
                        <header className="pt pb pl-x2 pr-x2 bb">
                            <h3>Active w/ header and footer in primary state (w/ shadow)</h3>
                        </header>
                        <section className="pt pb pl-x2 pr-x2">
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nisl
                                nisi, feugiat a arcu sed, vehicula volutpat magna. Morbi hendrerit
                                arcu eget elit tincidunt sollicitudin. Suspendisse rutrum lacinia
                                bibendum. Cras congue massa non arcu varius tempus. Duis massa
                                tortor, elementum sed convallis vitae, aliquam quis neque. Nullam a
                                eros eu purus convallis elementum. Praesent justo urna, feugiat sed
                                nisi nec, consequat aliquam dui.
                            </p>
                        </section>
                        <footer className="pt pb pl-x2 pr-x2 bt">
                            <button className="btn btn-default">Call to action</button>
                        </footer>
                    </div>
                </div>
            </div>
            <div className="row mb">
                <div className="col-xs-4">
                    <div className="card card-primary">
                        <section className="pt pb pl-x2 pr-x2">
                            <h4>Owner's Interest</h4>
                            <address>
                                <small className="text-muted">First Name Insured</small>
                                <br />
                                John Mulaney <br />
                                123 Dury Lane <br />
                                Margaritaville, FL 04995 <br />
                            </address>
                            <address>
                                <small className="text-muted">Project Address</small>
                                <br />
                                66 Project Lane
                                <br />
                                Margaritaville, FL 04995
                                <br />
                            </address>
                        </section>
                    </div>
                </div>
            </div>
            <Valuer value={'apple'}>
                <AccordionRadio
                    options={[
                        {
                            label: 'Apple',
                            value: 'apple',
                            price: '$10'
                        },
                        {
                            label: 'Orange',
                            value: 'orange',
                            price: '$100'
                        },
                        {
                            label: 'Banana',
                            value: 'banana',
                            price: '$1000'
                        }
                    ]}
                    type="circle"
                    name="fruits-51"
                />
            </Valuer>
            <Valuer value={['apple']}>
                <AccordionCheckbox
                    options={[
                        {
                            label: 'Apple',
                            value: 'apple',
                            price: '$10'
                        },
                        {
                            label: 'Orange',
                            value: 'orange',
                            price: '$100'
                        },
                        {
                            label: 'Banana',
                            value: 'banana',
                            price: '$1000'
                        }
                    ]}
                    type="square"
                    name="fruits-51"
                />
            </Valuer>
            <ContactUs user={user} />
        </div>
    );
}
